// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import React from 'react';

import bolt11 from 'bolt11';

import { lazyLoad } from '../utils/lazyLoad';
import register from '../utils/register';

import './i18n';

// Load and initialize flagsmith only if it hasn't been loaded before.
// The import statement will define window.flagsmith
(async () => {
  if (!window.loadingFlagsmith) {
    window.loadingFlagsmith = true;
    await import('flagsmith');
    await window.flagsmith.init({
      environmentID: window.gon.flagsmithEnvironmentID,
      enableLogs: window.gon.flagsmithClientLogs,
      api: window.gon.flagsmithClientApi,
      cacheFlags: window.gon.flagsmithClientCacheFlags,
      cacheOptions: {
        ttl: 60 * 1000,
        skipAPI: true,
        loadStale: true,
      },
      identity: window.gon.current_user?.email,
    });
  }
})().catch(() => {});

const AlertsBar = React.lazy(() => import('../features/alerts_bar/alerts_bar'));

const BillingInvoices = React.lazy(
  () => import('../features/billing_invoices/pages/BillingInvoicesList'),
);
const KushkiDepositResult = React.lazy(() =>
  import('../features/deposits/pages/KushkiDepositResult').then((module) => ({
    default: module.KushkiDepositResult,
  })),
);
const Loans = React.lazy(() => import('../features/loans/pages/Loans'));
const LoansSummary = React.lazy(() => import('../features/loans_summary/pages/LoansSummary'));
const MobileConfirmation = React.lazy(
  () => import('../features/mobile_confirmation/mobile_confirmation'),
);
const ReferralsPayouts = React.lazy(
  () => import('../features/referrals-payouts/pages/ReferralsPayouts'),
);
const Referrals = React.lazy(() => import('../features/referrals/pages/Referrals'));
const CancelInstructions = React.lazy(
  () => import('../features/withdrawal_verification_form/components/cancelInstructions'),
);
const SidebarTutorial = React.lazy(() => import('../shared/components/SidebarTutorial'));

const Alert = React.lazy(() =>
  import('../shared/components/Alert').then((module) => ({
    default: module.Alert,
  })),
);

const ActionsSidebar = lazyLoad({
  folder: 'ActionsSideBar',
  componentPath: 'index',
  component: 'ActionsSidebar',
  basePath: 'shared/components',
});

const TradingView = lazyLoad({
  folder: 'tradingview',
  componentPath: 'pages/TradingView',
  component: 'TradingView',
  additionalTranslationFolders: ['tyc_signing'],
});

const RFQOrders = React.lazy(() =>
  import('../features/otc/pages/RFQOrders').then((module) => ({
    default: module.RFQOrdersWrapper,
  })),
);

const DepositsNavigation = lazyLoad({
  folder: 'deposits',
  componentPath: 'components/Navigation',
  component: 'DepositsNavigation',
});

const ToastContainer = React.lazy(() =>
  import('../shared/components/Toast').then((module) => ({
    default: module.ToastContainer,
  })),
);

const KushkiResults = lazyLoad({
  folder: 'deposits',
  componentPath: 'pages/CardDeposit',
  component: 'CardDepositWrapper',
});

/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */

if (module.hot) {
  module.hot.accept();
}

require('./application.css');

register('alerts-bar', AlertsBar);
register('billing-invoices', BillingInvoices);
register('mobile-confirmation', MobileConfirmation);
register('loans', Loans);
register('loans-summary', LoansSummary);
register('referrals-payouts', ReferralsPayouts);
register('referrals', Referrals);
register('kushki-deposit-result', KushkiDepositResult);
register('sidebar-tutorial', SidebarTutorial);
register('withdrawal-cancel-instructions', CancelInstructions);
register('alert', Alert);
register('tradingview', TradingView);
register('rfq-orders', RFQOrders);
register('deposits-navigation', DepositsNavigation);
register('actions-sidebar', ActionsSidebar);
register('toast-container', ToastContainer);
register('kushki-results', KushkiResults);

(global as unknown).lightningPayReq = bolt11;

/* eslint-enable @typescript-eslint/no-unsafe-call */
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/* eslint-enable @typescript-eslint/no-unsafe-return */
